import * as entity from '@common/domain/entities/ProjectJobNumber'
import * as app from '@framework/app';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { IDataEndPoint } from '../../../framework/interfaces/IEntity';
import { ViewType } from '../../../framework/core/Enums';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
export class ProjectJobNumberEndPoints extends entity.ProjectJobNumberEndPoints { }

export class SiteProjectJobNumberEndPoints extends entity.ProjectJobNumberEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/ProjectJobNumber/lazyPersite/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/ProjectJobNumber/lazyPersiteCount/" + serviceCommand.context.entityId}, method: "POST" };
}

export class ProjectJobNumberFormFields extends entity.ProjectJobNumberFormFields {
  constructor() {
    super();
	 try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
       if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
       if (this["changedBy"]) this.splice(this.indexOf(this["changedBy"]), 1)
       if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
       if (this["siteId"]) this.splice(this.indexOf(this["siteId"]), 1)
       this.contractManagerId.name = "Contract Manager";
       this.contractManagerId.viewType = ViewType.Dropdown;
       this.contractManagerId.dataDisplayField = "name";
       this.contractManagerId.dataIdField = "id";
       this.contractManagerId.dataEndPoint = { url: app.config.controllerRouteRoot + "/contractManager/dropdown" };
    } catch  { }
  }
}

export class ProjectJobNumberForm extends entity.ProjectJobNumberForm {
  protected projectJobNumberFormEndPoints: ProjectJobNumberEndPoints = new ProjectJobNumberEndPoints();
  protected projectJobNumberFormFields: ProjectJobNumberFormFields = new ProjectJobNumberFormFields();
  public onLoaded: Function = function (context: any, entity?: any) {
    if (context.entityId == "00000000-0000-0000-0000-000000000000") {
      context.entityData.siteId = context.parent.previousEntityId;
    } 
  }
}

export class ProjectJobNumberListColumns extends entity.ProjectJobNumberListColumns {
  constructor() {
    super();
	    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
          if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
          if (this["changedBy"]) this.splice(this.indexOf(this["changedBy"]), 1)
          if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
          if (this["siteId"]) this.splice(this.indexOf(this["siteId"]), 1)
          this.splice(this.indexOf(this.contractManagerId), 1);
          this.push(FormBuilderControlListHelper.getListColumn("contractManager.name", "Contract Manager", null, null, "contractManager_name"));
    } catch  { }
  }
}

export class ProjectJobNumberList extends entity.ProjectJobNumberList {
  protected projectJobNumberListEndPoints: ProjectJobNumberEndPoints = new ProjectJobNumberEndPoints();
  protected projectJobNumberListColumns: ProjectJobNumberListColumns = new ProjectJobNumberListColumns();
}

export class SiteProjectJobNumberList extends entity.ProjectJobNumberList {
  protected projectJobNumberListEndPoints: SiteProjectJobNumberEndPoints = new SiteProjectJobNumberEndPoints();
  protected projectJobNumberListColumns: ProjectJobNumberListColumns = new ProjectJobNumberListColumns();
}


export class BladeSetup {
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(1);
    }
  }
}

//export class ProjectJobNumberGeneratedForm extends entity.ProjectJobNumberGeneratedForm {
  //protected detailPageComponentForm: ProjectJobNumberForm = new ProjectJobNumberForm();
//};

//export class ProjectJobNumberListPageComponent extends entity.ProjectJobNumberListPageComponent {
  //protected listPageComponentList: ProjectJobNumberList = new ProjectJobNumberList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class ProjectJobNumberBlade extends entity.ProjectJobNumberBlade {};
//export class ProjectJobNumberListBlade extends entity.ProjectJobNumberListBlade {};

